export default __webpack_public_path__ + "static/1-interface-7b67a59ba29175f354a5c7be7db5cf64.jpg";